import React from 'react';

import Lottie from 'react-lottie';

import { LogoButton } from '../buttons/LogoButton';
import LogoIcon from '../../../assets/images/Learnit_logo.svg';
import loadingSpinnerAnimation from '../../../assets/animations/loading-spinner.json';

interface ILoadingOverlay {
  text: string;
}

const animationOptions = {
  loop: true,
  autoplay: true,
  animationData: loadingSpinnerAnimation,
};

const LoadingOverlay: React.FC<ILoadingOverlay> = ({ text }) => {
  return (
    <div className="absolute top-0 left-0 w-screen h-screen flex flex-col bg-white z-[9999]">
      <div className="pt-6 mx-auto auth-container">
        <LogoButton logo={LogoIcon} />
      </div>
      <div className="flex flex-col items-center justify-end h-1/2">
        <div>
          <Lottie options={animationOptions} height={200} width={400} />
        </div>
        <div className="font-bold text-center w-80 text-regular text-grey-700">
          {text}
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
